import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { CognitoUser, AuthenticationDetails } from "amazon-cognito-identity-js";
import UserPool from "./UserPool";
import { AccessToken, RefreshToken } from "./AccessToken";
import LoginImg from "../../assets/img/hlthtek-login.jpeg";
import LoginImg2 from "../../assets/img/hlthtek_login.jpg";
import { ChangeCursor } from "../hlthtek-demo/components/MiscFunctions";
import InfoVideo from "../../assets/abha_info.mp4";
// import 'bootstrap/dist/css/bootstrap.min.css';
import img1 from "../../assets/images/gallery/HTMATE_Icon.png";
import img2 from "../../assets/images/gallery/Login Page Hero Image.jpg";
import img3 from "../../assets/images/gallery/Hpr.jpg";
import img4 from "../../assets/images/gallery/abdm.jpeg";
import img5 from "../../assets/images/gallery/fhrabdm.jpg";
import HTMateIcon from "../../assets/images/gallery/B-T-HTMATE.svg";
import { toast } from "react-toastify";

import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import "./LoginPage.scss";
import Carousel from "react-bootstrap/Carousel";
import { Divider } from "@mui/material";
import { borderRadius } from "@mui/system";
// const Item = styled('div')(({ theme }) => ({
//   backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: 'center',
//   color: theme.palette.text.secondary,
// }));

// const Item = styled('div')(({ theme }) => ({
//   backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: 'center',
//   color: theme.palette.text.secondary,
//   height: '900px',
// }));

const Item = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  // height: '60vh',
  overflow: "hidden",
  minHeight: "60vh",
}));

// const imgStyle = {
//   // width: '100%',
//   height: "80vh",
//   // maxHeight: '63vh',
//   // objectFit: 'cover',
//   borderRadius: "15px",
// };

// const imgStyle = {
//   width: '100%',
//   height: 'auto',
//   maxHeight: '63vh',
//   objectFit: 'cover',
//   borderRadius: "15px"
// };

function ElectronicHealthRecords() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    reset,
  } = useForm();
  const {
    register: register1,
    handleSubmit: handleSubmit1,
    formState: { errors: errors1 },
    watch: watch1,
    setValue: setValue1,
  } = useForm();
  const history = useHistory();
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [verifyCodeForm, setVerifyCodeForm] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const RESEND_OTP_TIMER = process.env.REACT_APP_RESEND_OTP_TIMER;
  const environment = process.env.REACT_APP_ENVIRONMENT;
  // Function to toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    sessionStorage.clear();
  }, []);

  const onSubmit = async (data) => {
    setButtonDisabled(true);
    setTimeout(() => {
      setButtonDisabled(false);
    }, RESEND_OTP_TIMER);
    //ChangeCursor();

    if (environment !== "PROD") {
      AccessToken(data.userName, data.password);
      setTimeout(() => {
        const role = sessionStorage.getItem("roleType");
        if (role === "admin") {
          //ChangeCursor();
          history.push("/hlthtek-admin-demo");
        } else if (role === "facility admin") {
          //ChangeCursor();
          history.push("/hlthtek-admin-demo");
        } else if (role === "facility user") {
          //ChangeCursor();video
          history.push("/hlthtek-demo");
        } else if (role === "customer admin") {
          //ChangeCursor();
          history.push("/hlthtek-admin-demo");
        } else if (role === "partner admin") {
          //ChangeCursor();
          history.push("/hlthtek-admin-demo");
        } else {
          //ChangeCursor();
          history.push("/hlthtek-demo");
        }
      }, 3000);
    } else {
      const cognitoUser = new CognitoUser({
        Username: data.userName,
        Pool: UserPool,
      });

      const authDetails = new AuthenticationDetails({
        Username: data.userName,
        Password: data.password,
      });

      setUser(data.userName);
      setPassword(data.password);
      try {
        cognitoUser.authenticateUser(authDetails, {
          onSuccess: () => {
            cognitoUser.getAttributeVerificationCode("email", {
              onSuccess: (success) => {
                console.log(success);
                setVerifyCodeForm(true);
                //ChangeCursor();
                reset();
              },
              onFailure: (err) => {
                console.log(err.message);
                toast.error(err);
                //ChangeCursor();
              },
            });
          },
          onFailure: (err) => {
            if (err.code === "UserNotConfirmedException") {
              console.log(
                "User account is not confirmed yet, please follow a link sent to your gmail to confirm you account!"
              );
              toast.error(
                "User account is not confirmed yet, please follow a link sent to your gmail to confirm you account!"
              );
            } else {
              console.log(err.message);
              toast.error(err.message);
            }
            //ChangeCursor();
          },
        });
      } catch (error) {
        if (error === "Error: Network Error") {
          console.log("System is under maintenance.Please try again.");
          toast.error("System is under maintenance.Please try again.");
        } else {
          console.log("Invalid user or password.");
          toast.error("Invalid user or password.");
        }
        //ChangeCursor();
      }
    }
  };

  const onSubmit1 = async (data) => {
    //ChangeCursor();
    var role = "";
    var email = "";
    var name = "";
    var facility_name = "";

    const cognitoUser = new CognitoUser({
      Username: user,
      Pool: UserPool,
    });

    const authDetails = new AuthenticationDetails({
      Username: user,
      Password: password,
    });

    try {
      cognitoUser.authenticateUser(authDetails, {
        onSuccess: () => {
          cognitoUser.verifyAttribute("email", data.verifyCode, {
            onSuccess: () => {
              cognitoUser.getUserAttributes(function (err, result) {
                if (err) {
                  toast.error(err.message || JSON.stringify(err));
                  //ChangeCursor();
                  return;
                } else {
                  console.log(result);
                  sessionStorage.setItem("userName", user);
                  for (var i = 0; i < result.length; i++) {
                    if (result[i].getName() == "custom:role") {
                      role = result[i].getValue();
                      console.log("role", role);
                      sessionStorage.setItem("roleType", role);
                    }
                    if (result[i].getName() == "custom:name") {
                      name = result[i].getValue();
                      sessionStorage.setItem("name", name);
                      // console.log("testing..",name)
                    }
                    if (result[i].getName() == "custom:facility_name") {
                      facility_name = result[i].getValue();
                      sessionStorage.setItem("facility_name", facility_name);
                    }
                    if (result[i].getName() === "email") {
                      email = result[i].getValue();
                      sessionStorage.setItem("email", email);
                    }
                  }
                  if (role === "admin") {
                    AccessToken(user, password);
                    setTimeout(() => {
                      //ChangeCursor();
                      history.push("/hlthtek-admin-demo");
                    }, 2000);
                  } else if (role === "facility admin") {
                    AccessToken(user, password);
                    setTimeout(() => {
                      //ChangeCursor();
                      history.push("/hlthtek-admin-demo");
                    }, 2000);
                  } else if (role === "facility user") {
                    AccessToken(user, password);
                    setTimeout(() => {
                      //ChangeCursor();
                      history.push("/hlthtek-demo");
                    }, 2000);
                  } else if (role === "customer admin") {
                    AccessToken(user, password);
                    setTimeout(() => {
                      //ChangeCursor();
                      history.push("/hlthtek-admin-demo");
                    }, 2000);
                  } else if (role === "partner admin") {
                    AccessToken(user, password);
                    setTimeout(() => {
                      //ChangeCursor();
                      history.push("/hlthtek-admin-demo");
                    }, 2000);
                  } else if (role === "doctor") {
                    AccessToken(user, password);
                    setTimeout(() => {
                      //ChangeCursor();
                      history.push("/doctor/landing");
                    }, 2000);
                  } else if (role === "lab user") {
                    AccessToken(user, password);
                    setTimeout(() => {
                      //ChangeCursor();
                      history.push("/hlthtek-demo");
                    }, 2000);
                  } else {
                    AccessToken(user, password);
                    setTimeout(() => {
                      //ChangeCursor();
                      history.push("/hlthtek-demo");
                    }, 2000);
                  }
                }
              });
            },
            onFailure: (err) => {
              console.log(err.message);
              toast.error(err.message);
              //ChangeCursor();
            },
          });
        },
        onFailure: (err) => {
          console.log(err.message);
          toast.error(err.message);
          //ChangeCursor();
        },
      });
    } catch (error) {
      if (error === "Error: Network Error") {
        console.log("System is under maintenance.Please try again.");
        toast.error("System is under maintenance.Please try again.");
      } else {
        toast.error("Invalid user or password.");
        console.log("Invalid user or password.");
      }
      //ChangeCursor();
    }
  };

  const resendCode = () => {
    setButtonDisabled(true);
    setTimeout(() => {
      setButtonDisabled(false);
    }, RESEND_OTP_TIMER);
    //ChangeCursor();
    const cognitoUser = new CognitoUser({
      Username: user,
      Pool: UserPool,
    });

    const authDetails = new AuthenticationDetails({
      Username: user,
      Password: password,
    });
    cognitoUser.authenticateUser(authDetails, {
      onSuccess: () => {
        cognitoUser.getAttributeVerificationCode("email", {
          onSuccess: (success) => {
            console.log(success);
            setVerifyCodeForm(true);
            //ChangeCursor();
          },
          onFailure: (err) => {
            console.log(err.message);
            toast.error(err);
            //ChangeCursor();
          },
        });
      },
      onFailure: (err) => {
        if (err.code === "UserNotConfirmedException") {
          console.log(
            "User account is not confirmed yet, please follow a link sent to your gmail to confirm you account!"
          );
          toast.error(
            "User account is not confirmed yet, please follow a link sent to your gmail to confirm you account!"
          );
        } else {
          console.log(err.message);
          toast.error(err.message);
        }
        //ChangeCursor();
      },
    });
  };

  const handlePlay = () => {
    let vid = document.getElementById("myVideo");
    if (vid.paused) {
      vid.play();
    } else {
      vid.pause();
    }
  };

  return (
    <div className="signupbox">
      <div className="wrapper">
        <div
          className="footer"
          style={{ display: "flex", flexDirection: "row" }}
        >
          <Box sx={{ width: "100%" }}>
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              style={{
                backgroundImage: "url('../../assets/images/backgrounds/2.jpg')",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                style={{
                  backgroundImage:
                    "url('../../assets/images/backgrounds/2.jpg')",
                }}
              >
                <Item
                  style={{
                    marginTop: "12px",
                    backgroundImage:
                      "url('../../assets/images/backgrounds/2.jpg')",
                  }}
                >
                  <Carousel style={{ marginBottom: "1%", objectFit: "cover" }}>
                    <Carousel.Item>
                      <img
                        className="d-block w-100 carousel-image"
                        src={img2}
                        alt="First slide"
                      />
                      <Carousel.Caption></Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                      <img
                        className="d-block w-100 carousel-image"
                        src={img3}
                        alt="Second slide"
                      />
                      <Carousel.Caption></Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                      <img
                        className="d-block w-100 carousel-image"
                        src={img2}
                        alt="First slide"
                      />
                      <Carousel.Caption></Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                      <img
                        className="d-block w-100 carousel-image"
                        src={img5}
                        alt="Third slide"
                      />
                      <Carousel.Caption></Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                      <img
                        className="d-block w-100 carousel-image"
                        src={img2}
                        alt="First slide"
                      />
                      <Carousel.Caption></Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                      <img
                        className="d-block w-100 carousel-image"
                        src={img4}
                        alt="Third slide"
                      />
                      <Carousel.Caption></Carousel.Caption>
                    </Carousel.Item>
                  </Carousel>
                </Item>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <Item
                  style={{
                    marginTop: "12px",
                    backgroundImage:
                      "url('../../assets/images/backgrounds/2.jpg')",
                  }}
                >
                  {!verifyCodeForm ? (
                    <div className="footer-widget-contact additional-footer-styles">
                      {/* <img src={HTMateIcon} style={{ borderRadius: "5px" }} /> */}
                      <img
                        src={HTMateIcon}
                        alt="HT Mate Icon"
                        style={{
                          borderRadius: "5px",
                          width: "100%",
                          maxWidth: "150px",
                          height: "auto",
                        }}
                      />

                      <form
                        className="contact-list list-unstyled"
                        name="login"
                        id="login"
                        onSubmit={handleSubmit(onSubmit)}
                      >
                        <li>
                          <h6>HT-BRIDGE Your Digital Healthcare Partner</h6>
                        </li>
                        <li>
                          <div className="col-sm-12 col-md-12 col-lg-12">
                            <input
                              name="userName"
                              type="text"
                              className="form-control"
                              required={true}
                              Placeholder="Username"
                              {...register("userName", {
                                required: "Facility ID is required.",
                              })}
                            />
                          </div>
                        </li>
                        <li>
                          <div
                            className="col-sm-12 col-md-12 col-lg-12"
                            style={{ position: "relative" }}
                          >
                            <input
                              name="password"
                              className="form-control"
                              type={showPassword ? "text" : "password"}
                              required={true}
                              placeholder="Password"
                              {...register("password", {
                                required: "Facility ID is required.",
                              })}
                            />
                            <span
                              className="password-toggle"
                              onClick={togglePasswordVisibility}
                              style={{
                                position: "absolute",
                                right: "40px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                              }}
                            >
                              {/* Use an icon (e.g., Font Awesome) for the eye icon */}
                              {showPassword ? (
                                <i className="fas fa-eye-slash"></i>
                              ) : (
                                <i className="fas fa-eye"></i>
                              )}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="col-sm-12 col-md-12 col-lg-12">
                            <button
                              className="btn btn__secondary  mt-10"
                              type="submit"
                            >
                              Submit
                            </button>
                          </div>
                        </li>
                      </form>
                      {/* <div className="d-flex align-items-center" style={{ paddingTop: '20px' }}>
                                            Doesn't have an account? 
                                                <a href="/register" className="btn btn__primary btn__link mr-30">
                                                    <i className="icon-arrow-right"></i> <span>Click here to Register</span>
                                                </a>
                                            </div> */}
                      {/* <div
                        className="d-flex align-items-center"
                        style={{ paddingTop: "20px" }}
                      >
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <a href="#" className="btn btn__primary btn__link mr-30">
                            <i className="icon-arrow-right"></i>{" "}
                            <span>Get Directions</span>
                          </a>
                          <a href="#" className="btn btn__primary btn__link mr-30">
                            <i className="icon-arrow-right"></i>{" "}
                            <span>Get Directions</span>
                          </a>
                        </div>

                        <ul className="social-icons list-unstyled mb-0">
                          <li>
                            <a href="#">
                              <i className="fab fa-facebook-f"></i>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <i className="fab fa-instagram"></i>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <i className="fab fa-twitter"></i>
                            </a>
                          </li>
                        </ul>
                      </div> */}
                      <div
                        className="d-flex align-items-center"
                        style={{ paddingTop: "20px" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {/* <a href="#" className="btn btn__primary btn__link mr-30">
                              <i className="icon-arrow-right"></i>{" "}
                              <span>Get Directions</span>
                            </a> */}
                            <ul
                              className="social-icons list-unstyled mb-0"
                              style={{ display: "flex", marginLeft: "60px" }}
                            >
                              <li style={{ marginRight: "10px" }}>
                                <a href="#">
                                  <i className="fab fa-facebook-f"></i>
                                </a>
                              </li>
                              <li style={{ marginRight: "10px" }}>
                                <a href="#">
                                  <i className="fab fa-instagram"></i>
                                </a>
                              </li>
                              <li style={{ marginRight: "10px" }}>
                                <a href="#">
                                  <i className="fab fa-twitter"></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                          <a
                            href="/contact"
                            className="btn btn__primary btn__link mr-30"
                          >
                            <i className="icon-arrow-right"></i>{" "}
                            <span>Contact Hlthtek Helpdesk</span>
                          </a>
                        </div>
                      </div>
                      <div style={{ marginTop: "10px", color: "#0e204d" }}>
                        <span style={{ color: "#0e204d" }}>
                          Login to access your secure and personalized health
                          platform.
                        </span>
                        <span style={{ color: "#0e204d" }}>
                          Experience the future of healthcare with Hlthtek.com's
                          powerful EHR system aka HTMate!
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="footer-widget-contact additional-footer-styles">
                      {/* <h6 className="footer-widget__title color-heading">
        Code, <span>Required!</span>
      </h6> */}
                      {/* <img src={HTMateIcon} style={{ borderRadius: "5px" }} /> */}
                      <img
                        src={HTMateIcon}
                        alt="HT Mate Icon"
                        style={{
                          borderRadius: "5px",
                          width: "100%",
                          maxWidth: "150px",
                          height: "auto",
                        }}
                      />
                      <form
                        autoComplete="off"
                        className="contact-list list-unstyled"
                        name="code_confirm"
                        id="code_confirm"
                        onSubmit={handleSubmit1(onSubmit1)}
                      >
                        {/* <li>
          <h5>Please enter the code sent.</h5>
        </li> */}
                        <li>
                          <h5>Your Digital Healthcare Partner</h5>
                        </li>
                        <li>
                          <div className="col-sm-12 col-md-12 col-lg-12">
                            <input
                              name="verifyCode"
                              id="verifyCode"
                              className="form-control"
                              type="number"
                              required={true}
                              Placeholder="Verify Code"
                              {...register1("verifyCode", {
                                required: "Verify Code is required.",
                              })}
                            />
                          </div>
                        </li>
                        <li>
                          <div
                            className="col-sm-12 col-md-12 col-lg-12"
                            // style={{ paddingLeft: "25%" }}
                          >
                            <div>
                              <button
                                className="btn btn__secondary  mt-10"
                                type="submit"
                              >
                                Submit
                              </button>
                            </div>
                            <div>
                              <button
                                className="btn btn__secondary  mt-10"
                                type="button"
                                disabled={buttonDisabled}
                                onClick={() => resendCode()}
                              >
                                Resend Code
                              </button>
                            </div>
                            {/* <div>
                              <button
                                className="btn btn__secondary  mt-10"
                                onClick={() => {
                                  setValue1("verifyCode", "");
                                  setVerifyCodeForm(false);
                                }}
                                type="submit"
                              >
                                Cancel
                              </button>
                            </div> */}
                          </div>
                        </li>
                      </form>
                      {/* <div
        className="d-flex align-items-center"
        style={{ paddingTop: "20px" }}
      >
        <a
          href="https://www.abdm.gov.in/"
          className="btn btn__primary btn__link mr-30"
        >
          <i className="icon-arrow-right"></i>{" "}
          <span>Know More on ABDM</span>
        </a>
        <ul className="social-icons list-unstyled mb-0">
          <li>
            <a href="#">
              <i className="fab fa-facebook-f"></i>
            </a>
          </li>
          <li>
            <a href="#">
              <i className="fab fa-instagram"></i>
            </a>
          </li>
          <li>
            <a href="#">
              <i className="fab fa-twitter"></i>
            </a>
          </li>
        </ul>
      </div> */}
                      <div
                        className="d-flex align-items-center"
                        style={{ paddingTop: "20px" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {/* <a href="#" className="btn btn__primary btn__link mr-30">
          <i className="icon-arrow-right"></i>{" "}
          <span>Get Directions</span>
        </a> */}
                            <ul
                              className="social-icons list-unstyled mb-0"
                              style={{ display: "flex", marginLeft: "60px" }}
                            >
                              <li style={{ marginRight: "10px" }}>
                                <a href="#">
                                  <i className="fab fa-facebook-f"></i>
                                </a>
                              </li>
                              <li style={{ marginRight: "10px" }}>
                                <a href="#">
                                  <i className="fab fa-instagram"></i>
                                </a>
                              </li>
                              <li style={{ marginRight: "10px" }}>
                                <a href="#">
                                  <i className="fab fa-twitter"></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                          <a
                            href="/contact"
                            className="btn btn__primary btn__link mr-30"
                          >
                            <i className="icon-arrow-right"></i>{" "}
                            <span>Contact Hlthtek Helpdesk</span>
                          </a>
                        </div>
                      </div>
                      <div style={{ marginTop: "10px", color: "#0e204d" }}>
                        <span style={{ color: "#0e204d", fontWeight: "bold" }}>
                          Login to access your secure and personalized health
                          platform.
                        </span>
                        <span style={{ color: "#0e204d", fontWeight: "bold" }}>
                          Experience the future of healthcare with Hlthtek.com's
                          powerful EHR system aka HTMate!
                        </span>
                      </div>
                    </div>
                  )}
                </Item>
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                style={{
                  backgroundImage:
                    "url('../../assets/images/backgrounds/2.jpg')",
                }}
              >
                <Item
                  style={{
                    backgroundImage:
                      "url('../../assets/images/backgrounds/2.jpg')",
                  }}
                >
                  <section className="contact-info py-0">
                    <div className="container">
                      <div className="row row-no-gutter boxes-wrapper">
                        <div className="col-sm-12 col-md-6">
                          <div className="contact-box">
                            <div
                              className="contact__icon mb-10"
                              style={{ margin: "auto" }}
                            >
                              <img
                                src="../../assets/images/icons/ehr_00.png"
                                alt="icon"
                              />
                            </div>
                            <div className="contact__content">
                              <h2 className="contact__title">
                                {" "}
                                <a
                                  href="/resarch/home"
                                  className="contact__title"
                                >
                                  Key Features:
                                </a>
                              </h2>
                              <p className="contact__desc">
                                <li>
                                  <strong>
                                    Seamlessly Integrated Clinical Processes
                                    (e-Prescriptions):
                                  </strong>{" "}
                                  Manage your practice efficiently with a
                                  comprehensive and intuitive EHR that
                                  streamlines clinical workflows and
                                  e-Prescriptions.
                                </li>
                                <li>
                                  <strong>
                                    ABDM Longitudinal Health Records:
                                  </strong>{" "}
                                  Access and manage complete patient health
                                  information, including medical history,
                                  medications, allergies, and more, all linked
                                  to your ABHA account.
                                </li>
                                <li>
                                  <strong>Evidence-Based Care:</strong> Make
                                  informed decisions with access to the latest
                                  clinical guidelines, research, and
                                  evidence-based protocols integrated into your
                                  EHR.
                                </li>
                                <li>
                                  <strong>Patient-Focused Design:</strong>{" "}
                                  Empower patients with secure access to their
                                  health information, promoting patient
                                  engagement and active participation in their
                                  care.
                                </li>
                              </p>
                            </div>
                            {/* <!-- /.contact__content  --> */}
                          </div>
                        </div>

                        <div className="col-sm-12 col-md-6">
                          <div className="contact-box">
                            <div
                              className="contact__icon mb-10"
                              style={{ margin: "auto" }}
                            >
                              <img
                                src="../../assets/images/icons/ehr_02.png"
                                alt="icon"
                              />
                            </div>
                            {/* <!-- /.contact__icon  --> */}
                            <div className="contact__content">
                              <h2 className="contact__title">
                                {" "}
                                <a
                                  href="/doctor/home"
                                  className="contact__title"
                                >
                                  Benefits for You:
                                </a>
                              </h2>
                              <p className="contact__desc">
                                <li>
                                  <strong>Increased Efficiency:</strong>{" "}
                                  Streamline your practice workflow, reduce
                                  administrative burden, and save valuable time
                                  with our intuitive EHR.
                                </li>
                                <li>
                                  <strong>Improved Patient Care:</strong> Make
                                  better decisions with access to complete and
                                  accurate patient data, ensuring personalized
                                  and evidence-based care.
                                </li>
                                <li>
                                  <strong>Enhanced Patient Engagement:</strong>{" "}
                                  Promote patient empowerment by providing
                                  secure access to their health records and
                                  encouraging active participation in their
                                  health journey.
                                </li>
                                <li>
                                  <strong>Compliant and Secure:</strong> Operate
                                  with confidence knowing our EHR system is
                                  designed to meet the latest regulations and
                                  data security standards, including ABDM
                                  compliance.
                                </li>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </Item>
              </Grid>
            </Grid>
          </Box>
        </div>
      </div>
    </div>
  );
}

export default ElectronicHealthRecords;
